import { render, staticRenderFns } from "./vBreakdownReportModal.vue?vue&type=template&id=5d80004c&scoped=true"
import script from "./vBreakdownReportModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./vBreakdownReportModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vBreakdownReportModal.vue?vue&type=style&index=0&id=5d80004c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d80004c",
  null
  
)

export default component.exports